export const RESERVATION_TTL_SECONDS = 900;
const TOLERANCE_SECONDS = 300;

export const secondsRemaining = ({ reservedAt, expiresAt }) => {
  const reservedMs = reservedAt ? new Date(reservedAt).getTime() : Date.now();
  const elapsed = (Date.now() - reservedMs) / 1000;
  const ttlRemaining = RESERVATION_TTL_SECONDS - elapsed;

  const absolute = expiresAt ? Date.parse(expiresAt) : NaN;
  const absoluteRemaining = Number.isNaN(absolute) ? null : (absolute - Date.now()) / 1000;

  const trustAbsolute =
    absoluteRemaining !== null &&
    absoluteRemaining > 0 &&
    absoluteRemaining <= RESERVATION_TTL_SECONDS + TOLERANCE_SECONDS;

  const remaining = trustAbsolute ? Math.min(absoluteRemaining, ttlRemaining) : ttlRemaining;

  return Math.max(0, Math.round(remaining));
};
